const truncateText = (text: string, maxLength: number) => {
  if (maxLength <= 0) return text;

  return text.length > maxLength ? text.slice(0, maxLength) + '...' : text;
};

export { truncateText };
